import { render, staticRenderFns } from "./HistoricoAbonos.vue?vue&type=template&id=57d33cce&"
import script from "./HistoricoAbonos.vue?vue&type=script&lang=js&"
export * from "./HistoricoAbonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports